export default theme => ({
  tabs: {
    width: "100%",
    overflow: "auto",
  },
  tab: {
    maxWidth: "420px",
  },
});
